import React, { FC } from 'react'
import classNames from 'classnames'
import format from 'date-fns/format'
import equal from 'fast-deep-equal'
import styles from 'styles/components/card.module.scss'
import text from 'styles/utility/text.module.scss'
import { Card, CardInner } from 'components/Card'
import { ShopStripePayout } from 'types/graphql'
import { Spacer } from 'components/Utility'
import { Description, SubCaution } from 'components/Typography'

type Props = {
  payout: ShopStripePayout
  isPrinted?: boolean
}

const DepositHistoryCard: FC<Props> = React.memo(
  (props) => {
    const { payout, isPrinted } = props
    const { amount, arrivalDate, feeAmount, createdDate, status } = payout
    return (
      <Card>
        <CardInner>
          <h3 className={classNames(styles.title)}>入金履歴明細</h3>
          <Spacer size={16} />
          <ul className={styles.monthlyReport__list}>
            <li className={styles.monthlyReport__list__item}>
              <span>入金実行日時</span>
              <span>{createdDate}</span>
            </li>
            <li className={styles.monthlyReport__list__item}>
              <span>{status === 'paid' ? '入金日' : '入金予定日'}</span>
              <span>{format(new Date(arrivalDate), 'yyyy/MM/dd')}</span>
            </li>
            <li className={styles.monthlyReport__list__item}>
              <span>入金対象額</span>
              <span>{(amount + feeAmount).toLocaleString()}円</span>
            </li>
            <li className={styles.monthlyReport__list__item}>
              <span>振込手数料</span>
              <span>{feeAmount.toLocaleString()}円</span>
            </li>
            <li className={styles.monthlyReport__list__item}>
              <span>最終入金金額</span>
              <span className={classNames(text.color_orange_main)}>{amount.toLocaleString()}円</span>
            </li>
          </ul>
          <Spacer size={20} />
          <SubCaution
            caution={
              '※振込手数料には、決済代行サービスによる銀行振込手数料450円と対象金額の0.25%を差し引いた金額となります。'
            }
          />
          {isPrinted && (
            <>
              <Spacer size={20} />
              <Description description={'株式会社sacri'} align={'right'} />
            </>
          )}
        </CardInner>
      </Card>
    )
  },
  (prev, next) => equal(prev, next)
)

export default DepositHistoryCard
